import React, { useState, useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { SUBSCRIPTION_UPGRADE_ROUTE } from '../../routes.config';

export function QuotaExceededModal() {
  const [open, setOpen] = useState(false);
  const [quotaInfo, setQuotaInfo] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    function handleQuotaExceeded(e) {
      setQuotaInfo(e.detail);
      setOpen(true);
    }
    window.addEventListener('quotaExceeded', handleQuotaExceeded);
    return () => window.removeEventListener('quotaExceeded', handleQuotaExceeded);
  }, []);

  function handleClose() {
    setOpen(false);
    setQuotaInfo(null);
  }

  function handleUpgrade() {
    setOpen(false);
    setQuotaInfo(null);
    navigate({ to: SUBSCRIPTION_UPGRADE_ROUTE });
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      {quotaInfo && (
        <>
          <DialogTitle>Quota Exceeded</DialogTitle>
          <DialogContent>
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <WarningAmberOutlinedIcon color="warning" sx={{ fontSize: 64 }} />
            </Box>
            <Typography variant="h6" align="center" gutterBottom>
              You've reached your {quotaInfo.type ?? 'documents'} limit
            </Typography>
            <Alert severity="info" sx={{ mb: 2 }}>
              <strong>Current usage:</strong> {quotaInfo.used} / {quotaInfo.limit} {quotaInfo.type ?? 'documents'}
              <br />
              <strong>Resets:</strong> {quotaInfo.resetDate ? new Date(quotaInfo.resetDate).toLocaleDateString() : 'N/A'}
            </Alert>
            <Typography>
              Upgrade your plan to continue processing documents or wait until your quota resets.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>Not Now</Button>
            <Button variant="contained" onClick={handleUpgrade}>Upgrade Plan</Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  );
}
